module.exports = __webpack_public_path__ + "static/media/radiant-and-coolant-hoses-red.b062f8ff.svg";